/*
 * elfsight-lazy.js
 *
 * Defers Elfsight widgets until their container scrolls near the
 * viewport. Approach:
 *   1. On DOMContentLoaded, find every <div class="elfsight-sapp-*">
 *      (or "elfsight-app-*").
 *   2. Stash the class name in data-elf-pending-class, then strip
 *      the elfsight class. Elfsight's platform script only processes
 *      divs that still carry the class, so the heavy widget init
 *      (~277 KB JS + 800 ms main-thread time per widget) is skipped
 *      at first paint.
 *   3. Use IntersectionObserver to watch each placeholder. When the
 *      div enters within 200 px of the viewport, restore the original
 *      class — Elfsight's MutationObserver picks it up and renders
 *      the widget at that moment.
 *   4. Fallback for old browsers: defer to window.load.
 */
(function () {
  var SELECTOR = 'div[class*="elfsight-sapp-"], div[class*="elfsight-app-"]';

  function defer(el) {
    var classes = el.className.split(/\s+/);
    var elfClass = '';
    for (var i = 0; i < classes.length; i++) {
      if (/^elfsight-(s)?app-/.test(classes[i])) {
        elfClass = classes[i];
        break;
      }
    }
    if (!elfClass) return null;
    el.setAttribute('data-elf-pending-class', elfClass);
    el.className = el.className.replace(elfClass, '').trim();
    return elfClass;
  }

  function restore(el) {
    var cls = el.getAttribute('data-elf-pending-class');
    if (!cls) return;
    el.classList.add(cls);
    el.removeAttribute('data-elf-pending-class');
  }

  function init() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    var pending = [];
    for (var i = 0; i < nodes.length; i++) {
      if (defer(nodes[i])) pending.push(nodes[i]);
    }
    if (!pending.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            restore(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      pending.forEach(function (el) { io.observe(el); });
    } else {
      // Old browser fallback — restore after window.load.
      window.addEventListener('load', function () {
        pending.forEach(restore);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
